var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('vue-toastr',{ref:"toastr"}),_vm._v(" "),_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('AppSidebar'),_vm._v(" "),_c('router-view',{staticClass:"main"})],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-089ce00a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 385
// module chunks = 1